/* eslint-disable */
export const downloadSDKFile = (fileName, url) => {
  const sdklink = document.createElement("a");
  sdklink.className = "download-helper";
  sdklink.download = fileName;
  sdklink.href = url;
  sdklink.click();
};
